module.exports = __webpack_public_path__ + "assets/img/logo.ac282ec5.svg";